export enum VerifyRegisterDev {
  // OK, USED, KO
  OK = 'OK',
  USED = 'USED',
  KO = 'KO',
}